import "./BrauBevLogo.scss";
import logoBrauBev from "./../../../assets/logo_braubev.png";

export interface BrauBevLogoProps {
    isSmall: boolean;
    date: string;
    provider: string;
}

const BrauBevLogo = (props: BrauBevLogoProps) => {
    if(props.isSmall) {
        return (
            <div className="BrauBev-Logo-Small">
                <div className="Circle Bright-Green"/>
                <div className="Circle Dark-Green"/>
                <div className="Circle White">
                    <img src={logoBrauBev} />
                    <span style={{marginTop: "1em"}}>{props.date}</span>
                    <span>{props.provider}</span>
                </div>
            </div>
        )
    } else {
        return (
            <div className="BrauBev-Logo">
                <div className="Circle Bright-Green"/>
                <div className="Circle Dark-Green"/>
                <div className="Circle White">
                    <img src={logoBrauBev} />
                    <span style={{marginTop: "1em"}}>{props.date}</span>
                    <span>{props.provider}</span>
                </div>
            </div>
        )
    }
}

export default BrauBevLogo;